/* istanbul ignore file */
export enum StepNames {
  ClientDetailsAndInvoice = "Client details and invoice",
  PayeeDetails = "Payee Details",
  PaymentInstructions = "Payment instructions",
  Review = "Review",
  Complete = "Complete",
  Error = "Error",
}

export const SubmitForReviewText = "Submit for review";
